import React from "react";
import {Box, Button, Tab, Tabs} from "@mui/material";
import {Link} from "react-router-dom";
import User from "../../backend/User";
import AdminData from "../../backend/dataservices/AdminData";
import {fetchIsTenantAdmin} from "../../utils/TenantAdminAccess";

function AdminNavbar({initValue}) {

    const [value, setValue] = React.useState(initValue);
    const [hideTenantManagement, setHideTenantManagement] = React.useState(false);
    const [isTenantAdmin, setIsTenantAdmin] = React.useState(false);

    React.useEffect(() => {
        AdminData.getServerConfig().then(cfg => {
            if (cfg?.hideTenantManagement) setHideTenantManagement(true);
        }).catch(() => {});
        fetchIsTenantAdmin().then(setIsTenantAdmin);
    }, []);

    function handleChange(event, newValue) {
        setValue(newValue);
    }

    const hasRoleAndTenant = User.getRole() != null;

    return (
        <Box sx={{width: '100%', padding: '10px', boxSizing: 'border-box', borderBottom: '1px solid lightgrey', display: 'flex', alignItems: 'center'}}>
            <Tabs value={value} onChange={handleChange} variant={"fullWidth"} sx={{flexGrow: 1}}>
                <Tab label={"Benutzer"} value={"/admin/users"} component={Link} to={"/admin/users"}/>
                {!hideTenantManagement && isTenantAdmin && <Tab label={"Tenants"} value={"/admin/tenants"} component={Link} to={"/admin/tenants"}/>}
                {!hideTenantManagement && <Tab label={"Mitarbeiter"} value={"/admin/employees"} component={Link} to={"/admin/employees"}/>}
                <Tab label={"Audit"} value={"/admin/audit"} component={Link} to={"/admin/audit"}/>
            </Tabs>
            {hasRoleAndTenant && (
                <Button component={Link} to={User.getHomepage()} size="small" sx={{ml: 1, whiteSpace: 'nowrap'}}>
                    Zur App
                </Button>
            )}
        </Box>
    );
}

export default AdminNavbar;
